export const norm = (s) => (s || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export const matches = (q, ...fields) => {
  const n = norm(q);
  if (!n) return true;
  const digits = n.replace(/\D/g, "");
  return fields.some((f) => norm(f).includes(n) || (digits && /^\d+$/.test(n) && (f || "").toString().replace(/\D/g, "").includes(digits)));
};
